function divideThousands(number, divider = ' ') {
    return ('' + number).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1' + divider);
}

type FormatNumOptions = {
    zeroToFree?: boolean;
    addRoubleSign?: boolean;
    toFixed?: number;
    onlyDecimalToFixed?: number;
};
function formatNum(
    num: number | string,
    {
        zeroToFree,
        addRoubleSign,
        toFixed,
        onlyDecimalToFixed,
    }: FormatNumOptions = {},
) {
    num = +num;

    const isDecimal = num % 1 !== 0;

    if (
        toFixed !== undefined ||
        (onlyDecimalToFixed !== undefined && isDecimal)
    ) {
        num = (+num).toFixed(toFixed || onlyDecimalToFixed);
    }

    num = divideThousands(num);

    if (zeroToFree && num === '0') {
        num = 'бесплатно';
    } else if (addRoubleSign) {
        num += ' ₽';
    }

    return num;
}

function stringToUint8Array(string: string) {
    const uint8Array = new Uint8Array(string.length);

    for (let i = 0, count = string.length; i < count; i++) {
        uint8Array[i] = string.charCodeAt(i);
    }

    return uint8Array;
}

function uint8ArrayToString(uint8Array: Uint8Array) {
    let result = '';

    if (typeof TextDecoder === 'undefined') {
        result = uint8ArrayToString(uint8Array);
    } else {
        result = new TextDecoder('utf-8').decode(uint8Array);
    }

    return result;
}

function sizeInUtf8Bytes(str) {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    const m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
}

export const StringHelper = {
    /**
     * differences with padStart:
     * 'abc'.padStart(10, "foo") -> "foofoofabc"
     * stringHelper.padStartWithStrAsChar('abc', 10, 'foo') -> foofoofoofoofoofoofooabc
     */
    padStartWithStrAsChar: (text: string, minLength: number) => {
        let formattedText = '' + text;
        let needSpaces = minLength - formattedText.length;

        while (needSpaces > 0) {
            formattedText = '\u2006 ' + formattedText;
            needSpaces--;
        }

        return formattedText;
    },

    cropToChar(string, char) {
        const charPosition = string.indexOf(char);
        return charPosition !== -1 ? string.slice(0, charPosition) : string;
    },

    stringToBool: (str?: string | null | boolean): boolean => {
        if (typeof str === 'string') {
            str = str.toLowerCase();
            if (str === 'false') {
                return false;
            } else if (str === 'true') {
                return true;
            }
            console.error('got unknown string as bool:', str);
            return !!str;
        }
        return !!str;
    },

    upperFirstLetter(str: string) {
        return str[0].toUpperCase() + str.slice(1);
    },

    sizeInBytes(string: string): number {
        if (window.TextEncoder) {
            const encoder = new TextEncoder();
            return encoder.encode(string).length;
        }
        if (window.Blob && window.Blob.prototype.hasOwnProperty('size')) {
            return new Blob([string]).size;
        }
        return unescape(window.encodeURIComponent(string)).length;
    },

    formatNum,
    stringToUint8Array,
    uint8ArrayToString,
    sizeInUtf8Bytes,
};
